import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image11.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const SettingUpGameplayStep3 = () => (
  <Wrapper>
    <Container>
      <Text1>Setting Up Gameplay</Text1>
      <Text2>360 Peer Review</Text2>
      <Text3>
        You'll then need to decide the # of the peer assessments
        your students should complete as they play the exercise.
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>

      <Text3>
        It's recommended that your students complete at least 2 peer
        assessments: one after round 1 (awareness) and the other after
        the final round (improvement). <b>The final one impacts students' grades</b>.<br />
        <b className="black-note">Note:</b> The <b>Game Admin</b> section is where you'll go to create and/or modify
        peer evaluations and/or grading model.
      </Text3>
    </Container>
  </Wrapper>
);

export default SettingUpGameplayStep3;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/setting-up-gameplay/step3.js